import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function Services() {
  const { ref, isVisible } = useScrollAnimation();

  const services = [
    {
      icon: 'ri-search-line',
      title: 'Operations Audit',
      description: 'A complete review of your workflows, documentation, communication, and compliance gaps.'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Workflow Automation',
      description: 'Clean systems that replace manual work, errors, and daily confusion.'
    },
    {
      icon: 'ri-file-text-line',
      title: 'Documentation and Compliance Support',
      description: 'Organized digital records that support accurate reporting and stronger inspections.'
    },
    {
      icon: 'ri-graduation-cap-line',
      title: 'Staff Training and Onboarding',
      description: 'Training your team on the systems that create consistency and confidence.'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Ongoing Operational Partner',
      description: 'Monthly support that keeps your facility running smoothly all year.'
    }
  ];

  return (
    <section ref={ref as React.RefObject<HTMLElement>} className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`text-center mb-16 ${isVisible ? 'opacity-100 animate-fade-in-up' : 'opacity-0'}`}>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Signature Services
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className={`bg-gray-50 p-8 rounded-xl hover-lift ${
                isVisible ? 'opacity-100 animate-fade-in-up' : 'opacity-0'
              }`}
              style={{ animationDelay: `${index * 0.1 + 0.2}s` }}
            >
              <div className="w-14 h-14 flex items-center justify-center bg-teal-600 rounded-full mb-6">
                <i className={`${service.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {service.title}
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
